module.exports = __webpack_public_path__ + "static/media/S3N13-1.b11a0cab.svg";